import React from "react"

interface PageErrorBoundaryProps {
  children: React.ReactNode
  fallback: React.ReactNode
  resetKey?: string
}

interface PageErrorBoundaryState {
  hasError: boolean
}

export class PageErrorBoundary extends React.Component<
  PageErrorBoundaryProps,
  PageErrorBoundaryState
> {
  state: PageErrorBoundaryState = { hasError: false }

  static getDerivedStateFromError(): PageErrorBoundaryState {
    return { hasError: true }
  }

  componentDidUpdate(prevProps: Readonly<PageErrorBoundaryProps>): void {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false })
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback
    }

    return this.props.children
  }
}
